import React from "react";
import { Form, Formik } from "formik";
import { defaultFilter, ISearchProps } from "./type";
import { SearchAccordion } from "../../../common";
import { generateSearchFormItem, getTreeData } from "../../../../utils/helper";
import { useTranslation } from "react-i18next";

const Search = ({ filter, selectionList, data, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
                {
                  type: "multiSelect",
                  name: "club",
                  label: "ClubManagement.club",
                  treeData: getTreeData(selectionList["club"]),
                },
                {
                  type: "number",
                  name: "level",
                  label: "ClubManagement.level",
                },
              ],
              defaultFilter(),
              t,
              data,
              "Club Management"
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
